;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "D1MzXC9x5e"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  initRating();
  function initRating(){
  if(!document.querySelector('#lh-fake-review') && !window.SPR && (window.LAYOUTHUB_LIVE === true || window.location.protocol === 'blob:' ))
    {
      jQuery.get('https://productreviews.shopifycdn.com/assets/v4/spr.js', function(code) {
        var regex = new RegExp(['"','/','/'].join(''),'gm');
        code = code.replace(regex, '"https://').replace(/SPR\./g,'window.SPR.').replace('window.SPR=','window.SPR=window.SPR || ');
        code = code.replace('return r=t.remote_id.toString()','if(!t.remote_id)return 0;return r=t.remote_id.toString()');
        code = code.replace('return r.fn.serializeObject','return !r || !r.fb ? false : r.fn.serializeObject');
        var blob = new Blob([code], {
          type: "application/javascript"
        });
        var url = URL.createObjectURL(blob);
        var script = document.createElement("script");
        script.src = url;
        script.id = "lh-fake-review";
        script.type = "text/javascript";
        if (!window.SPR)
        document.head.append(script);
      })
    }
    else
    {
      if(window.SPR && window.SPR.$){
        window.SPR.loadjQueryExtentions(window.SPR.$);
        window.SPR.$(document).ready(function() {
            return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
        })
      }
    }
  }
 };						cb.bind($('section[data-section-id="D1MzXC9x5e"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="D1MzXC9x5e"]').get(0))({						url: "https://library.layouthub.com/HUB/files/Tm92LS0yMDE5/NTc0ODY0ODc5/First_release/pages/Glaz/main_collection/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "sz4cy4fgroa"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
    $(this).find('.lh-wrapper').each(function(index){
        if(section.settings.cd_type == 'by_date'){
            var countDownDate = new Date(section.settings.cd_date).getTime();
        }else{
            var numDays = parseInt(section.settings.cd_number_day);
            var dateObj = new Date();
            var countDownDate = dateObj.setTime(dateObj.getTime() + (numDays * 24 * 60 * 60 * 1000));
        }
        var t = $(this);
        var x = setInterval(function() {
          var now = new Date().getTime();
          var distance = countDownDate - now;
          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          if(days.toString().length  == 1){
            days = '0' + days;
          }
          var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          if(hours.toString().length  == 1){
            hours = '0' + hours;
          }
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          if(minutes.toString().length  == 1){
              minutes = '0' + minutes;
          }
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);
          if(seconds.toString().length  == 1){
              seconds = '0' + seconds;
          }

          t.find('.lh-day .lh-value').html(days);
          t.find('.lh-hour .lh-value').html(hours);
          t.find('.lh-minute .lh-value').html(minutes);
          t.find('.lh-second .lh-value').html(seconds);

          if (distance < 0) {
            clearInterval(x);
            if(section.settings.cd_text_expire != ''){
                t.find('.lh-cd-wrap').html('<span class="lh-expired" >'+  section.settings.cd_text_expire +'</span>');
            }
          }
        }, 1000);
    });
 };						cb.bind($('section[data-section-id="sz4cy4fgroa"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="sz4cy4fgroa"]').get(0))({						url: "https://library.layouthub.com/HUB/files/U2VwLS0yMDIw/NTk5NDQ1MzA1/shopify-third-release/pages/gMyRNP3fLtnjOBlU/countdown-n/",						settings: {"cd_type":"fixed","cd_date":"2020 5 20 00:00:00","cd_number_day":"7","cd_text_expire":"EXPIRED TIME"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "994y62qo1fp"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="994y62qo1fp"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWFyLS0yMDIx/NjE1Mjc3MDI3/release-3-2021/pages/A86iQazbFCg9LR3W/banner/",						settings: {}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');window.addEventListener("load",()=>{let a=document.querySelector("body"),b=document.createElement(Math.random().toString(36).replace(/\d*/g,"").substr(2,4));b.setAttribute("style",["position:relative","top: 0px","left: 0px","display: inline-block","height: 30px","line-height: 30px","font-size: 15px","width: 100%","text-align: center","opacity: 1","z-index: 10000000000000000","text-indent: 0","color: #333","background: #fff",""].join(" !important;")),b.innerHTML="Page layout provided by &hearts; <a href=\"https://www.layouthub.com/?utm_source=client-site&utm_medium=footer&utm_campaign=freemium&utm_term=links&utm_content="+window.location.origin+"\">Layouthub.com</a>",a.appendChild(b)});